import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import RetroFreeDrawing from './RetroFreeDrawing';
import RetroPixelDrawer from './RetroPixelDrawer';
import RetroPixelChallenge from './RetroPixelChallenge';
import RetroLetterCatcher from './RetroLetterCatcher';
import ConfirmDialog from './ConfirmDialog';

const RetroLoadingGames = ({ 
  loadedImages = [], 
  totalExpected = 1,
  onGameComplete,
  GameComponent = RetroFreeDrawing,
  generatedImageUrl
}) => {
  const [gameResults, setGameResults] = useState(null);
  const [isGameActive, setIsGameActive] = useState(true);
  
  const handleGameComplete = useCallback((results) => {
    onGameComplete?.(results);
    setGameResults(results);
    setIsGameActive(false);
  }, [onGameComplete]);

  // Create a proper image object from the URL
  const generatedImage = generatedImageUrl ? {
    id: `generated-${Date.now()}`, // Generate a unique ID
    url: generatedImageUrl,
    s3Url: generatedImageUrl
  } : null;

  return (
    <motion.div 
      className="relative w-full rounded-xl overflow-hidden"
      style={{
        height: '200px',
        backgroundColor: 'rgba(0, 0, 0, 0.9)'
      }}
    >
      {/* Game container */}
      <div className="absolute inset-0">
        <GameComponent 
          isActive={isGameActive}
          showStartButton={false}
          onGameComplete={handleGameComplete}
          generatedImage={generatedImage}
        />
      </div>
    </motion.div>
  );
};

export default RetroLoadingGames; 